// Audio Tools — extra UI strings (how-it-works, mixer presets, stepper).
const en = {
  "at.how.title": "How it works",
  "at.how.s1": "Upload",
  "at.how.s1d": "Drop any song — MP3, WAV, FLAC…",
  "at.how.s2": "AI separates",
  "at.how.s2d": "Our model isolates vocals from the music.",
  "at.how.s3": "Mix & download",
  "at.how.s3d": "Balance the stems and export MP3 or WAV.",
  "at.how.private": "Private — files are only visible to you and auto-deleted.",
  "at.mix.all": "Full mix",
  "at.mix.karaoke": "Karaoke",
  "at.mix.acapella": "Acapella",
  "at.result.ready": "Your stems are ready",
  "at.result.duration": "Duration",
  "at.result.tempo": "Tempo",
  "at.result.key": "Key",
  "at.cancel": "Cancel",
  "at.cancelled": "Job cancelled",
};
const tr = {
  "at.how.title": "Nasıl çalışır?",
  "at.how.s1": "Yükle",
  "at.how.s1d": "Herhangi bir şarkıyı bırak — MP3, WAV, FLAC…",
  "at.how.s2": "AI ayırsın",
  "at.how.s2d": "Modelimiz vokali müzikten ayırır.",
  "at.how.s3": "Mixle & indir",
  "at.how.s3d": "Kanalları dengele, MP3 veya WAV olarak indir.",
  "at.how.private": "Gizli — dosyaları sadece sen görürsün, otomatik silinir.",
  "at.mix.all": "Tam mix",
  "at.mix.karaoke": "Karaoke",
  "at.mix.acapella": "Akapella",
  "at.result.ready": "Kanalların hazır",
  "at.result.duration": "Süre",
  "at.result.tempo": "Tempo",
  "at.result.key": "Ton",
  "at.cancel": "İptal et",
  "at.cancelled": "İşlem iptal edildi",
};
const es = {
  "at.how.title": "Cómo funciona",
  "at.how.s1": "Sube",
  "at.how.s1d": "Suelta cualquier canción — MP3, WAV, FLAC…",
  "at.how.s2": "La IA separa",
  "at.how.s2d": "Nuestro modelo aísla la voz de la música.",
  "at.how.s3": "Mezcla y descarga",
  "at.how.s3d": "Equilibra las pistas y exporta en MP3 o WAV.",
  "at.how.private": "Privado — solo tú ves tus archivos y se borran automáticamente.",
  "at.mix.all": "Mezcla completa",
  "at.mix.karaoke": "Karaoke",
  "at.mix.acapella": "Acapella",
  "at.result.ready": "Tus pistas están listas",
  "at.result.duration": "Duración",
  "at.result.tempo": "Tempo",
  "at.result.key": "Tono",
  "at.cancel": "Cancelar",
  "at.cancelled": "Trabajo cancelado",
};
export default { en, tr, es };
